import * as React from "react";
import {handleNavigation, routePaths} from "egold/routes";
import {imageBaseUrl} from "config";
import {useEffect} from "react";
import {AndroidApis} from "app";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
interface IConnectProps {
    isAndroid: boolean;
}

function OrderSuccess(props: IConnectProps) {
    useEffect(() => {
        clearStack();
        return () => clearStack();
    }, []);
    function clearStack() {
        if (props.isAndroid) {
            AndroidApis.clearWebStack();
        }
    }
    return (
        <div style={{marginTop: "50%", color: "#000000"}}>
            <div className="text-center">
                <img src={`${imageBaseUrl}/img/icons/eGold/Successful.png`}/>
                    <h4 className="mt-3">Order Successful</h4>
                    <span className="d-block "><small>Your order has been successfully placed.</small></span>
                    <button className="pt-2 mt-4 eGold-submit-btn"
                            style={{width: "75%", margin: "auto"}}
                            onClick={() => handleNavigation(routePaths.ORDERS)}
                    >
                        View Order
                    </button>
            </div>
        </div>
    );
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
       isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(OrderSuccess);
